<div class="modal-header">
    <h4 class="modal-title">Actualizar Vehículo</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss('Cross click')"></button>
</div>
<div class="modal-body">
    <form [formGroup]="form">
        <div class="row">
            <div class="col-12 col-sm-3">
                <label for="patente">Patente</label>
                <input type="patente" class="form-control" id="patente" formControlName="patente"
                    [ngClass]="{'is-invalid': form.controls['patente'].errors && form.controls['patente'].touched}">
                <div class="invalid-feedback">
                    Debe ingresar un valor en el campo
                </div>
                <div class="mb-4" *ngIf="!form.controls['patente'].errors || !form.controls['patente'].touched">
                </div>
            </div>
            <div class="col-12 col-sm-3">
                <label for="marca">Marca</label>
                <input type="marca" class="form-control" id="marca" formControlName="marca"
                    [ngClass]="{'is-invalid': form.controls['marca'].errors && form.controls['marca'].touched}">
                <div class="invalid-feedback">
                    Debe ingresar un valor en el campo
                </div>
                <div class="mb-4" *ngIf="!form.controls['marca'].errors || !form.controls['marca'].touched">
                </div>
            </div>
            <div class="col-12 col-sm-3">
                <label for="modelo">Modelo</label>
                <input type="modelo" class="form-control" id="modelo" formControlName="modelo"
                    [ngClass]="{'is-invalid': form.controls['modelo'].errors && form.controls['modelo'].touched}">
                <div class="invalid-feedback">
                    Debe ingresar un valor en el campo
                </div>
                <div class="mb-4" *ngIf="!form.controls['modelo'].errors || !form.controls['modelo'].touched">
                </div>
            </div>
            <div class="col-12 col-sm-3">
                <label for="year">Año</label>
                <input type="number" class="form-control" id="year" formControlName="year"
                    [ngClass]="{'is-invalid': form.controls['year'].errors && form.controls['year'].touched}">
                <div class="invalid-feedback">
                    Debe ingresar un valor en el campo
                </div>
                <div class="mb-4" *ngIf="!form.controls['year'].errors || !form.controls['year'].touched">
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-12 col-sm-6">
                <label for="unidad_medida">Unidad de Medida</label>
                <div class="form-group">
                    <select class="form-select" id="unidad_medida" formControlName="unidad_medida"
                        [ngClass]="{'is-invalid': form.controls['unidad_medida'].errors && form.controls['unidad_medida'].touched}">
                        <option [value]="0">Kilómetros</option>
                        <option [value]="1">Millas</option>
                    </select>
                </div>
            </div>

            <div class="col-12 col-sm-6">
                <label for="usuario_id">Cliente Dueño</label><label class="campo-opcional"> (Opcional)</label>
                <ng-select [items]="clientes" formControlName="usuario_id" bindValue="id" labelForId="usuario_id"
                    [searchFn]="searchFn" [virtualScroll]="true" [readonly]="form.controls['usuario_id'].disabled"
                    bindLabel="nombre"
                    [ngClass]="{'is-invalid': form.controls['usuario_id'].errors && form.controls['usuario_id'].touched}"
                    appendTo="body">
                    <ng-template ng-label-tmp let-item="item" let-index="index" let-search="searchTerm">
                        {{item.nombre}} {{item.apellido}}
                    </ng-template>
                    <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                        {{item.nombre}} {{item.apellido}}
                    </ng-template>
                </ng-select>
                <div class="invalid-feedback">
                    Debe ingresar un valor en el campo
                </div>
            </div>
        </div>
    </form>
    <br>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-success" (click)="guardar()">Actualizar</button>
    <button type="button" class="btn btn-secondary" (click)="activeModal.dismiss('Cancel click')">Cancelar</button>
</div>